import {
  all,
  call,
  put,
  SagaReturnType,
  select,
  takeEvery,
  takeLatest,
  takeLeading,
} from 'redux-saga/effects'

import { actions, selectors } from '..'
import { getAuthCookie, setAuthCookie } from '../../helpers/CookieHelpers'
import login from '../../rest/requests/auth/login'
import me from '../../rest/requests/auth/me'
import ApiSagas from '../api/sagas'

export default class AuthSagas {
  static *onInit() {
    const cookie = getAuthCookie()
    console.log('AUTH : init with cookie', cookie)
    if (cookie) {
      yield put(actions.auth.setImpersonate(cookie?.impersonate ?? false))
      yield put(actions.auth.setToken(cookie?.token))
    }

    yield call(AuthSagas.onMe)
  }

  static *onMe() {
    const isConnected: SagaReturnType<typeof selectors.auth.isConnected> =
      yield select(selectors.auth.isConnected)
    console.log('AUTH : is connected', isConnected)

    if (isConnected) {
      yield put(actions.auth.meIsLoading(true))

      const response = yield* ApiSagas.rest(me())

      if (response.data) {
        yield put(actions.auth.setUser(response.data))
      } else {
        yield put(actions.auth.resetAuth())
      }

      yield put(actions.auth.meIsLoading(false))
    }
  }

  static *onLoginRequest({
    payload,
  }: ReturnType<typeof actions.auth.loginRequest>) {
    const response = yield* ApiSagas.rest(login(payload))

    if (response.data) {
      setAuthCookie({ token: response.data.jwt, impersonate: false })
      yield put(actions.auth.setToken(response.data.jwt))
      yield put(actions.auth.setUser(response.data.user))
      yield put(actions.auth.loginSuccess())
    }
  }

  static *onLogout() {
    console.log('User logged off')
    setAuthCookie(null)
    yield put(actions.auth.resetAuth())
  }

  static *loop() {
    yield all([
      takeEvery(actions.auth.loginRequest, this.onLoginRequest),
      takeLeading(actions.auth.logout, this.onLogout),
      takeLatest(actions.auth.me, this.onMe),
    ])
  }
}
